module.exports = __webpack_public_path__ + "assets/img/fun.a474fc18.svg";